var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 87,
    viewBox: "0 0 121 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_26070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3747 87C6.65353 79.1917 1.83818 71.1292 0.379713 62.0964C-1.07876 53.0637 1.61736 42.7442 9.23325 37.7722C15.2092 33.8689 22.8525 33.9467 29.6039 31.6518C45.9586 26.0882 55.199 7.43649 71.4921 1.68618C84.062 -2.75323 98.7717 1.92311 108.016 11.5871C117.259 21.2511 121.368 35.1365 120.977 48.5516C120.587 61.9667 116.039 74.9719 109.881 86.8738L11.3747 87Z",
    fill: "#3E5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.102 22.5791H26.9541C24.1009 22.5791 21.7878 24.9159 21.7878 27.7985V81.3066C21.7878 84.1892 24.1009 86.526 26.9541 86.526H94.102C96.9552 86.526 99.2682 84.1892 99.2682 81.3066V27.7985C99.2682 24.9159 96.9552 22.5791 94.102 22.5791Z",
    fill: "#FFDCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 18.4168C42.8791 16.779 43.0897 14.6121 42.0369 13.0556C40.7668 11.174 38.1768 10.7676 35.9326 10.9803C31.6068 11.4005 27.608 13.462 23.9173 15.7812C20.9524 17.6455 17.5938 20.2776 17.9722 24.2553C18.2478 27.1521 20.1359 28.2001 22.8252 28.1136C28.8046 27.9147 38.8974 23.7918 41.9513 18.4168Z",
    fill: "#3E5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5546 27.4976V34.2233H20.0759V27.4976C20.0759 24.7806 22.6437 22.5791 25.7985 22.5791H91.8286C94.992 22.5791 97.5546 24.7806 97.5546 27.4976Z",
    fill: "#76CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5546 58.6546V81.9741C97.5546 84.4887 94.9869 86.5276 91.8286 86.5276H25.7985C22.6385 86.5276 20.0759 84.4887 20.0759 81.9741V34.1367H97.5546V58.6546Z",
    fill: "#FDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9616 29.8253C43.0289 29.8253 43.8942 28.8985 43.8942 27.7552C43.8942 26.6119 43.0289 25.6851 41.9616 25.6851C40.8942 25.6851 40.0289 26.6119 40.0289 27.7552C40.0289 28.8985 40.8942 29.8253 41.9616 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9771 18.3545H41.948C41.2692 18.3545 40.7189 18.9104 40.7189 19.5962V27.4184C40.7189 28.1041 41.2692 28.6601 41.948 28.6601H41.9771C42.6559 28.6601 43.2061 28.1041 43.2061 27.4184V19.5962C43.2061 18.9104 42.6559 18.3545 41.9771 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9337 29.8253C33.0011 29.8253 33.8664 28.8985 33.8664 27.7552C33.8664 26.6119 33.0011 25.6851 31.9337 25.6851C30.8664 25.6851 30.0011 26.6119 30.0011 27.7552C30.0011 28.8985 30.8664 29.8253 31.9337 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9474 18.3545H31.9217C31.242 18.3545 30.6909 18.9112 30.6909 19.5979V27.4166C30.6909 28.1034 31.242 28.6601 31.9217 28.6601H31.9474C32.6271 28.6601 33.1782 28.1034 33.1782 27.4166V19.5979C33.1782 18.9112 32.6271 18.3545 31.9474 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.895 29.8253C53.9624 29.8253 54.8277 28.8985 54.8277 27.7552C54.8277 26.6119 53.9624 25.6851 52.895 25.6851C51.8277 25.6851 50.9624 26.6119 50.9624 27.7552C50.9624 28.8985 51.8277 29.8253 52.895 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9087 18.3545H52.883C52.2033 18.3545 51.6522 18.9112 51.6522 19.5979V27.4166C51.6522 28.1034 52.2033 28.6601 52.883 28.6601H52.9087C53.5884 28.6601 54.1395 28.1034 54.1395 27.4166V19.5979C54.1395 18.9112 53.5884 18.3545 52.9087 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8284 29.8253C64.8958 29.8253 65.761 28.8985 65.761 27.7552C65.761 26.6119 64.8958 25.6851 63.8284 25.6851C62.761 25.6851 61.8958 26.6119 61.8958 27.7552C61.8958 28.8985 62.761 29.8253 63.8284 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8438 18.3545H63.8147C63.1359 18.3545 62.5856 18.9104 62.5856 19.5962V27.4184C62.5856 28.1041 63.1359 28.6601 63.8147 28.6601H63.8438C64.5226 28.6601 65.0729 28.1041 65.0729 27.4184V19.5962C65.0729 18.9104 64.5226 18.3545 63.8438 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7635 29.8253C75.8308 29.8253 76.6961 28.8985 76.6961 27.7552C76.6961 26.6119 75.8308 25.6851 74.7635 25.6851C73.6961 25.6851 72.8308 26.6119 72.8308 27.7552C72.8308 28.8985 73.6961 29.8253 74.7635 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7772 18.3545H74.7481C74.0693 18.3545 73.519 18.9104 73.519 19.5962V27.4184C73.519 28.1041 74.0693 28.6601 74.7481 28.6601H74.7772C75.456 28.6601 76.0063 28.1041 76.0063 27.4184V19.5962C76.0063 18.9104 75.456 18.3545 74.7772 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6969 29.8253C86.7643 29.8253 87.6296 28.8985 87.6296 27.7552C87.6296 26.6119 86.7643 25.6851 85.6969 25.6851C84.6296 25.6851 83.7643 26.6119 83.7643 27.7552C83.7643 28.8985 84.6296 29.8253 85.6969 29.8253Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7089 18.3545H85.6832C85.0034 18.3545 84.4524 18.9112 84.4524 19.5979V27.4166C84.4524 28.1034 85.0034 28.6601 85.6832 28.6601H85.7089C86.3886 28.6601 86.9397 28.1034 86.9397 27.4166V19.5979C86.9397 18.9112 86.3886 18.3545 85.7089 18.3545Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 43.1523H24.6859V49.1396H31.9355V43.1523Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 52.6675H24.6859V58.6547H31.9355V52.6675Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 62.1812H24.6859V68.1684H31.9355V62.1812Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9355 71.6948H24.6859V77.6821H31.9355V71.6948Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1037 43.1523H34.8541V49.1396H42.1037V43.1523Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1037 52.6675H34.8541V58.6547H42.1037V52.6675Z",
    fill: "#D53B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1037 62.1812H34.8541V68.1684H42.1037V62.1812Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1037 71.6948H34.8541V77.6821H42.1037V71.6948Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2719 43.1523H45.0223V49.1396H52.2719V43.1523Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2719 52.6675H45.0223V58.6547H52.2719V52.6675Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2719 62.1812H45.0223V68.1684H52.2719V62.1812Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2719 71.6948H45.0223V77.6821H52.2719V71.6948Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4401 43.1523H55.1906V49.1396H62.4401V43.1523Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4401 52.6675H55.1906V58.6547H62.4401V52.6675Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4401 62.1812H55.1906V68.1684H62.4401V62.1812Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4401 71.6948H55.1906V77.6821H62.4401V71.6948Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6083 43.1523H65.3588V49.1396H72.6083V43.1523Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6083 52.6675H65.3588V58.6547H72.6083V52.6675Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6083 62.1812H65.3588V68.1684H72.6083V62.1812Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6083 71.6948H65.3588V77.6821H72.6083V71.6948Z",
    fill: "#76CCCC",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7782 62.1812H75.5287V68.1684H82.7782V62.1812Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7782 43.1523H75.5287V49.1396H82.7782V43.1523Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7782 52.6675H75.5287V58.6547H82.7782V52.6675Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7782 71.6948H75.5287V77.6821H82.7782V71.6948Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9465 71.6948H85.6969V77.6821H92.9465V71.6948Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9465 43.1523H85.6969V49.1396H92.9465V43.1523Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9465 52.6675H85.6969V58.6547H92.9465V52.6675Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9465 62.1812H85.6969V68.1684H92.9465V62.1812Z",
    fill: "#D53B5C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 57.9231L35.9907 55.0609L36.66 54.492L38.098 56.4358L40.2891 53.3955L40.967 53.9541L38.1065 57.9231Z",
    fill: "#FDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1499 86.7853H25.7986C22.5016 86.7853 19.8192 84.627 19.8192 81.9724V48.126H20.3328V81.9741C20.3328 84.3417 22.7841 86.2682 25.7986 86.2682H94.1499V86.7853Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8131 55.5903H97.2996V66.9612H97.8131V55.5903Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8132 44.6827H97.2996V27.4975C97.2996 24.9294 94.8466 22.8402 91.8304 22.8402H25.7986C24.7229 22.8334 23.6641 23.1113 22.7276 23.6461C21.228 24.5108 20.3311 25.9566 20.3311 27.4975H19.8175C19.8175 25.7681 20.8087 24.1598 22.4708 23.1965C23.4849 22.6165 24.6316 22.3148 25.7969 22.3214H91.8304C95.129 22.3214 97.8132 24.644 97.8132 27.4975V44.6827Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3764 34.0503H30.0011V34.5691H92.3764V34.0503Z",
    fill: "#343643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.486 86.417H7.42395V86.9358H114.486V86.417Z",
    fill: "#525460"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_26070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 87,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.78dfb19afa066465aa1930184207e156.svg";
export { ForwardRef as ReactComponent };